/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 19:28:03 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { useForm } from 'react-final-form';
import { ThumbUp, ThumbDown } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import { actionButtonStyles } from 'styles';

const TowerInspectionActionToolbar = ({
  classes,
  setShowConfirmModal,
  isSubmittingInspection,
  setIsSubmittingInspection,
  setFormData,
  notify,
  checklistApproved,
  status,
}) => {
  const buttonClasses = actionButtonStyles(25);
  const form = useForm();

  const approve = status => {
    displayModal(status);
  };

  const disaprove = status => {
    const formState = form.getState();
    if (Object.keys(formState.errors).length > 0) {
      form.blur('reviewerComments'); // we call this to highlight the empty field
      return notify('ra.message.invalid_form', 'warning');
    }
    displayModal(status);
  };

  const displayModal = status => {
    // const formState = form.getState();
    // const shouldValidateReviewerComments =
    //   checklistApproved === false || checklistApproved === undefined;
    const reviewerComments = form.getFieldState('reviewerComments').value;
    setIsSubmittingInspection(true);
    setShowConfirmModal(true);
    return setFormData({ status, reviewerComments });
  };

  return (
    <div className={(classes.root, buttonClasses.root)}>
      <ActionButton
        icon={<ThumbUp />}
        name={'actions.approve'}
        disabled={
          isSubmittingInspection ||
          checklistApproved === false ||
          status === 'APPROVED'
        }
        onClick={() => approve('APPROVED')}
        className={buttonClasses.approve}
      />
      {/* <ActionButton
        icon={<ThumbDown />}
        name={'actions.reinspect'}
        disabled={isSubmittingInspection}
        onClick={() => disaprove('NOT_APPROVED')}
        className={buttonClasses.reinspect}
      /> */}
      <ActionButton
        icon={<ThumbDown />}
        name={'actions.doNotUse'}
        // disabled={status === 'DO_NOT_USE' || isSubmittingInspection}
        onClick={() => disaprove('DO_NOT_USE')}
        className={buttonClasses.decline}
      />
    </div>
  );
};

export default TowerInspectionActionToolbar;
